module.exports = __webpack_public_path__ + "static/media/cards-w.a7853945.svg";